import { artists } from "@/constants/artists/artists";
import { instruments } from "@/constants/instruments";
import {
  minutesFree,
  minutesSubscriptionFirst,
  minutesSubscriptionSecond,
  namePublicSubscriptionFirst,
  namePublicSubscriptionFree,
  namePublicSubscriptionSecond,
  namePublicSubscriptionThird,
  numberOfCustomModelsFirst,
  numberOfCustomModelsFree,
  numberOfCustomModelsSecond,
  numberOfCustomModelsThird,
  numberOfMixedModelsFree,
  stripeIdSubscriptionFirstMonthly,
  stripeIdSubscriptionFirstYearly,
  stripeIdSubscriptionFirstYearlyBlackFriday,
  stripeIdSubscriptionSecondMonthly,
  stripeIdSubscriptionSecondYearly,
  stripeIdSubscriptionSecondYearlyBlackFriday,
  stripeIdSubscriptionThirdMonthly,
  stripeIdSubscriptionThirdYearly,
  stripeIdSubscriptionThirdYearlyBlackFriday,
} from "@/constants/payment";
import { PricePlan } from "@/types/types";

export const pricePlans: PricePlan[] = [
  {
    prices: null,
    name: namePublicSubscriptionFree,
    description: "Get a taste of Audimee.",
    features: [
      `${minutesFree} min of conversions`,
      `${numberOfCustomModelsFree} custom voice model slots`,
      `${artists.filter((artist) => artist.meta.free).length} royalty-free voices`,
      "No access to the harmony maker",
      "Pitch editor",
      `${instruments.length} instruments`,
      "Vocal isolator",
      "Stem splitter",
      `${numberOfMixedModelsFree} mixed voices`,
      "Personal use only",
      "MP3 downloads",
      // "Limited access to cover acapellas",
      "Can't save conversions/isolations",
    ],
    highlighted: false,
  },

  {
    prices: {
      monthly: {
        stripeId: stripeIdSubscriptionFirstMonthly,
        priceAmountPerMonth: 12,
      },
      yearly: {
        stripeId: stripeIdSubscriptionFirstYearly,
        priceAmountPerMonth: 9,
        priceAmountPerMonthBlackFriday: 8.5,
        discountRounded: 30,
        stripeIdBlackFriday: stripeIdSubscriptionFirstYearlyBlackFriday,
      },
    },
    name: namePublicSubscriptionFirst,
    description: "For the hobbyist.",
    features: [
      `${minutesSubscriptionFirst / 60} hour of conversions/mo`,
      `${numberOfCustomModelsFirst} custom voice model slot`,
      "All royalty-free voices + new",
      "Harmony maker",
      "Pitch editor",
      `${instruments.length} instruments`,
      "Vocal isolator",
      "Stem splitter",
      "Mixed voices",
      "Commercial use",
      "WAV (24-bit) downloads",
      // "Cover acapellas",
      "Save conversions/isolations",
    ],
    highlighted: false,
  },
  {
    prices: {
      monthly: {
        stripeId: stripeIdSubscriptionSecondMonthly,
        priceAmountPerMonth: 25,
      },
      yearly: {
        stripeId: stripeIdSubscriptionSecondYearly,
        priceAmountPerMonth: 19,
        priceAmountPerMonthBlackFriday: 15,
        discountRounded: 40,
        stripeIdBlackFriday: stripeIdSubscriptionSecondYearlyBlackFriday,
      },
    },
    name: namePublicSubscriptionSecond,
    description: "For the creator.",
    features: [
      `${minutesSubscriptionSecond / 60} hours of conversions/mo`,
      `${numberOfCustomModelsSecond} custom voice model slots`,
      "All royalty-free voices + new",
      "Harmony maker",
      "Pitch editor",
      `${instruments.length} instruments`,
      "Vocal isolator",
      "Stem splitter",
      "Mixed voices",
      "Commercial use",
      "WAV (24-bit) downloads",
      // "Cover acapellas",
      "Save conversions/isolations",
    ],
    highlighted: true,
  },

  {
    prices: {
      monthly: {
        stripeId: stripeIdSubscriptionThirdMonthly,
        priceAmountPerMonth: 49,
      },
      yearly: {
        stripeId: stripeIdSubscriptionThirdYearly,
        priceAmountPerMonth: 37,
        priceAmountPerMonthBlackFriday: 24,
        discountRounded: 50,
        stripeIdBlackFriday: stripeIdSubscriptionThirdYearlyBlackFriday,
      },
    },
    name: namePublicSubscriptionThird,
    description: "For the professional.",
    features: [
      // minutesSubscriptionThird is unlimited
      `Unlimited conversions/mo`,
      `${numberOfCustomModelsThird} custom voice model slots`,
      "All royalty-free voices + new",
      "Harmony maker",
      "Pitch editor",
      `${instruments.length} instruments`,
      "Vocal isolator",
      "Stem splitter",
      "Mixed voices",
      "Commercial use",
      "WAV (24-bit) downloads",
      // "Cover acapellas",
      "Save conversions/isolations",
    ],
    highlighted: false,
  },
];
